/*
 * Окно ИИ-консультанта WAU (docs/assistant/04-consultant-chat.md).
 *
 * Сервер — помощник на wau.ru, магазин global. Надписи окна приходят с
 * сервера на языке витрины при старте разговора. Разговор продолжается при
 * переходе между страницами: токен — в localStorage, реплики — с сервера.
 *
 * Запросы идут через App Proxy витрины (/apps/wau/chat/…): Shopify
 * пересылает их на wau.ru. Браузер покупателя обращается только к витрине —
 * в части стран и сетей сервер в России не открывается, и окно показывало
 * одну ошибку. Прокси может не дождаться долгого ответа модели; сервер ответ
 * всё равно записывает, и окно забирает его опросом.
 *
 * Тело — JSON с типом text/plain: и прямой запрос на wau.ru, если прокси в
 * настройках нет, обходится без предварительного OPTIONS.
 *
 * Пилот — доля посетителей из настроек темы, по тому же номеру, что у
 * умного поиска. Без localStorage окна нет.
 *
 * Эксперт (канал WAU Global в RetailCRM): после передачи окно остаётся,
 * реплики покупателя уходят эксперту, его ответы окно забирает опросом —
 * раз в 3 с, пока окно открыто и вкладка видна, иначе раз в 30 с. Эксперт
 * пишет по-русски, покупатель видит перевод; оригинал — по нажатию на
 * пометку «переведено».
 */
(function () {
  'use strict';

  var cfg = window.WAUChatConfig;
  if (!cfg || !cfg.api || document.getElementById('wau-chat')) {
    return;
  }

  var STORAGE = 'wau_global_chat';
  var api = (cfg.proxy || cfg.api.replace(/\/$/, '')) + '/chat/';
  // Ответ, которого не дождался прокси: 20 опросов раз в 3 с — минута.
  var RECOVER_TRIES = 20;
  // Черновик ответа: первый запрос — когда модель успела написать начало,
  // дальше — пока ответ не придёт.
  var DRAFT_FIRST_MS = 1500;
  var DRAFT_EVERY_MS = 700;

  function bucket() {
    try {
      var value = localStorage.getItem('wau_search_bucket');
      if (value === null) {
        value = String(Math.floor(Math.random() * 100));
        localStorage.setItem('wau_search_bucket', value);
      }
      return Number(value);
    } catch (e) {
      return 100;
    }
  }
  if (bucket() >= Number(cfg.pilot || 0)) {
    return;
  }

  function storage(value) {
    try {
      if (value === undefined) return localStorage.getItem(STORAGE) || '';
      value ? localStorage.setItem(STORAGE, value) : localStorage.removeItem(STORAGE);
    } catch (e) {
      return '';
    }
    return value;
  }

  var token = storage();
  var pass = '';
  var PASS = 'wau_global_pass';
  var ui = {};
  var started = false;
  var busy = false;
  var state = 'bot';
  var mode = '';
  var lastExpertId = 0;
  var lastId = 0;
  var pollTimer = null;

  var root = el('div', 'wau-chat');
  root.id = 'wau-chat';
  root.innerHTML =
    '<button type="button" class="wau-chat__launcher" aria-expanded="false" aria-controls="wau-chat-dialog" aria-label="Ask WAU">'
    + '<span class="wau-chat__spark" aria-hidden="true">✦</span><span class="wau-chat__launcher-text">WAU</span></button>'
    + '<div class="wau-chat__dialog" id="wau-chat-dialog" role="dialog" aria-modal="false" aria-label="WAU" hidden>'
    + '<div class="wau-chat__head"><div class="wau-chat__titles"><b class="wau-chat__title">WAU</b><div class="wau-chat__sub"></div></div>'
    + '<button type="button" class="wau-chat__expert" hidden></button>'
    + '<button type="button" class="wau-chat__close" aria-label="Close">×</button></div>'
    + '<div class="wau-chat__log" aria-live="polite"></div>'
    + '<div class="wau-chat__chips"></div>'
    + '<form class="wau-chat__form"><textarea class="wau-chat__input" rows="1" maxlength="1000"></textarea>'
    + '<button type="submit" class="wau-chat__send" aria-label="Send">➤</button></form>'
    + '<div class="wau-chat__note"></div></div>';
  document.body.appendChild(root);

  var launcher = root.querySelector('.wau-chat__launcher');
  var dialog = root.querySelector('.wau-chat__dialog');
  var log = root.querySelector('.wau-chat__log');
  var chips = root.querySelector('.wau-chat__chips');
  var form = root.querySelector('.wau-chat__form');
  var input = root.querySelector('.wau-chat__input');
  var callExpert = root.querySelector('.wau-chat__expert');

  launcher.addEventListener('click', function () {
    dialog.hidden ? open() : close();
  });
  // Как «Позвать эксперта» в шапке окна wau.ru: передать разговор человеку.
  callExpert.addEventListener('click', function () {
    contact();
  });
  root.querySelector('.wau-chat__close').addEventListener('click', close);
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    ask(input.value);
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      ask(input.value);
    }
  });
  dialog.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  // Консультант встроен в кнопку Help (sections/contact-widget.liquid):
  // первый пункт её панели — «Спросить WAU», своей кнопки у окна нет, и
  // окно открывается над Help. Пункт в разметке спрятан и показывается
  // только здесь — посетителю вне пилота его не видно. Нет виджета
  // (секцию убрали) — окно остаётся со своей кнопкой слева.
  var help = document.querySelector('contact-widget');
  var helpItem = help && help.querySelector('[data-wau-chat-item]');
  var helpToggle = help && help.querySelector('.contact-widget__toggle');
  if (helpItem) {
    root.classList.add('wau-chat--embedded');
    helpItem.hidden = false;
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-wau-chat-open]')) return;
      e.preventDefault();
      if (typeof help.close === 'function') help.close();
      open();
    });
    // Пока окно открыто, Help — его крестик: закрывает окно, а не
    // открывает поверх него панель мессенджеров. Перехват на погружении —
    // раньше обработчика самого виджета.
    if (helpToggle) {
      helpToggle.addEventListener('click', function (e) {
        if (dialog.hidden) return;
        e.stopImmediatePropagation();
        close();
      }, true);
    }
  }

  // Над закреплёнными полосами внизу экрана — нижним меню и панелью покупки.
  // Тот же расчёт, что у виджета контактов (assets/contact-widget.js), но свой:
  // на телефоне виджета нет, и брать его подъём было не у кого — кнопка
  // уходила под панель покупки. Меряется верхняя граница занятых полос.
  function lift() {
    var height = window.innerHeight;
    var top = height;
    ['.mobile-sticky-bar', '.sticky-atc-bar'].forEach(function (selector) {
      var bar = document.querySelector(selector);
      if (!bar) return;
      var cs = getComputedStyle(bar);
      if (cs.display === 'none' || cs.visibility === 'hidden') return;
      var box = bar.getBoundingClientRect();
      if (box.top >= height || box.height < 1) return;
      top = Math.min(top, box.top);
    });
    root.style.setProperty('--wau-chat-offset', Math.round(height - top) + 'px');
  }
  lift();
  window.addEventListener('scroll', lift, { passive: true });
  window.addEventListener('resize', lift);

  function open() {
    unread(false);
    schedulePoll(0);
    dialog.hidden = false;
    launcher.setAttribute('aria-expanded', 'true');
    root.classList.add('wau-chat--open');
    if (helpItem) {
      help.setAttribute('data-wau-chat', 'open');
      if (helpToggle) helpToggle.setAttribute('aria-expanded', 'true');
    }
    (started ? Promise.resolve() : start()).then(function () {
      input.focus();
      scroll();
    });
  }

  function close() {
    schedulePoll(30000);
    dialog.hidden = true;
    launcher.setAttribute('aria-expanded', 'false');
    root.classList.remove('wau-chat--open');
    if (helpItem) {
      help.removeAttribute('data-wau-chat');
      if (helpToggle) {
        helpToggle.setAttribute('aria-expanded', 'false');
        // На телефоне плавающей Help нет — фокус некуда возвращать.
        if (helpToggle.offsetParent) helpToggle.focus();
      }
    } else {
      launcher.focus();
    }
  }

  // Точка «новый ответ эксперта» — на той кнопке, которой окно открывают:
  // своей, Help и пункте «помощь» нижнего меню на телефоне.
  function unread(on) {
    launcher.classList.toggle('wau-chat__launcher--unread', on);
    if (!helpItem) return;
    [helpToggle, helpItem].concat(Array.prototype.slice.call(document.querySelectorAll('[data-contact-widget-open]')))
      .forEach(function (node) {
        if (!node) return;
        on ? node.setAttribute('data-wau-unread', '') : node.removeAttribute('data-wau-unread');
      });
  }

  function base() {
    return { token: token, pass: pass, locale: cfg.locale || 'en', country: cfg.country || 'US', page: location.pathname, productId: cfg.productId || 0 };
  }

  // Заказы вошедшего покупателя (SPEC-34 §12 в sales631/wauru): вход
  // подтверждает Shopify через App Proxy (/apps/wau/identity) — сервер wau.ru
  // выдаёт пропуск на час, окно несёт его в каждом запросе. Гость пропуска
  // не получает, и помощник предложит ему войти. Пропуск держится в
  // sessionStorage: вышел из аккаунта — витрина скажет loggedIn: false, и он стирается.
  function identity() {
    if (!cfg.loggedIn || !cfg.proxy) {
      remember(null);
      return Promise.resolve();
    }
    var saved = remember();
    if (saved) {
      pass = saved;
      return Promise.resolve();
    }
    return fetch(cfg.proxy + '/identity', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : {}; })
      .then(function (data) {
        if (data && data.customer && data.pass) {
          pass = data.pass;
          remember({ pass: data.pass, until: Date.now() + (Number(data.ttl) || 3600) * 1000 - 60000 });
        }
      })
      .catch(function () {});
  }

  function remember(value) {
    try {
      if (value === undefined) {
        var saved = JSON.parse(sessionStorage.getItem(PASS) || 'null');
        return saved && saved.until > Date.now() ? saved.pass : '';
      }
      value ? sessionStorage.setItem(PASS, JSON.stringify(value)) : sessionStorage.removeItem(PASS);
    } catch (e) {
      return '';
    }
    return '';
  }

  function call(action, data) {
    return fetch(api + action + '/', {
      method: 'POST',
      credentials: 'omit',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(Object.assign(base(), data || {}))
    }).then(function (response) {
      return response.json().catch(function () {
        return { error: 'internal' };
      }).then(function (json) {
        json.status = response.status;
        return json;
      });
    });
  }

  function start() {
    started = true;
    return identity().then(function () {
      return call('start');
    }).then(function (data) {
      if (!data || data.enabled === false) {
        root.remove();
        return;
      }
      if (data.error) {
        started = false;
        if (data.status === 404 && token) {
          token = storage('');
          return start();
        }
        system(ui.error || 'Something went wrong. Please try again.');
        return;
      }
      token = storage(data.token);
      ui = data.ui || {};
      applyUi();
      log.innerHTML = '';
      (data.messages || []).forEach(function (message) {
        render(message);
        noteExpert(message);
      });
      renderChips(data.suggestions || []);
      state = data.state || 'bot';
      mode = data.operatorMode || '';
      if (withExpert()) {
        expertNote(data);
      }
    }, function () {
      started = false;
      system('Something went wrong. Please try again.');
    });
  }

  function applyUi() {
    root.querySelector('.wau-chat__sub').textContent = ui.subtitle || '';
    input.placeholder = ui.placeholder || '';
    root.querySelector('.wau-chat__send').setAttribute('aria-label', ui.send || 'Send');
    root.querySelector('.wau-chat__close').setAttribute('aria-label', ui.close || 'Close');
    callExpert.textContent = ui.call_expert || '';
    expertButton();
    var note = root.querySelector('.wau-chat__note');
    note.textContent = (ui.disclaimer || '') + ' ';
    if (cfg.privacyUrl) {
      var link = el('a');
      link.href = cfg.privacyUrl;
      link.textContent = ui.privacy || 'Privacy policy';
      note.appendChild(link);
    }
  }

  function ask(text) {
    text = String(text || '').trim();
    if (!text || busy) return;
    input.value = '';
    renderChips(withExpert() ? [ui.resume] : []);
    render({ role: 'user', blocks: [{ type: 'text', text: text }] });
    busy = true;
    // Отвечает эксперт — «печатает» показывать нечестно: ответит человек, и не сразу.
    var typing = el('div', 'wau-chat__typing');
    if (!withExpert()) {
      typing.innerHTML = '<span></span><span></span><span></span>';
      log.appendChild(typing);
      scroll();
    }
    if (!withExpert()) {
      startDraft(typing);
    }
    identity().then(function () {
      // waiting: окно показывает ответ помощника и пока разговор ждёт эксперта.
      return call('send', { text: text, waiting: 1 });
    }).then(function (data) {
      if (lost(data)) {
        recover(typing, RECOVER_TRIES);
        return;
      }
      stopDraft();
      typing.remove();
      busy = false;
      // Переслано эксперту; ответ помощника в ожидании (interim) — показываем.
      if (data.forwarded && !data.interim) {
        return;
      }
      if (data.error) {
        if (data.status === 404) {
          token = storage('');
          started = false;
        }
        system(data.message || ui.error || 'Something went wrong. Please try again.');
        return;
      }
      render({ id: data.handover ? 0 : data.messageId, role: 'assistant', blocks: data.blocks, rateable: data.rateable });
      track('wau_chat_message');
      if (data.interim) {
        // Разговор по-прежнему у эксперта: пометка о нём уже на экране.
        // «Вопрос решён» — ответ помог, эксперта можно не ждать.
        renderChips((data.solvedChip ? [data.solvedChip] : []).concat([ui.resume]));
        return;
      }
      if (data.solved) {
        // Эксперту ушла заметка, разговор снова у помощницы.
        clearTimeout(pollTimer);
        state = 'bot';
        mode = '';
      }
      renderChips(data.suggestions || []);
      handedOver(data);
    }, function () {
      if (!withExpert()) {
        recover(typing, RECOVER_TRIES);
        return;
      }
      stopDraft();
      typing.remove();
      busy = false;
      system(ui.error || 'Something went wrong. Please try again.');
    });
  }

  /*
   * Начало ответа, пока модель пишет остальное. Ответ на вопрос приходит
   * через App Proxy Shopify, а тот отдаёт его только целиком, поэтому
   * черновик окно забирает отдельными короткими запросами (chat/draft).
   * Готовый ответ встаёт на место черновика; пустой черновик — ответ будет
   * другим, снова «печатает». Сервер без chat/draft — просто ждём ответ.
   */
  var draft = null;

  function startDraft(typing) {
    stopDraft();
    var state = { node: null, text: '', timer: null, typing: typing };
    var tick = function () {
      call('draft').then(function (data) {
        if (draft !== state) return;
        if (data.status === 404) {
          stopDraft();
          return;
        }
        showDraft(state, String(data.text || ''));
        state.timer = setTimeout(tick, DRAFT_EVERY_MS);
      }, function () {
        if (draft === state) state.timer = setTimeout(tick, DRAFT_EVERY_MS);
      });
    };
    draft = state;
    state.timer = setTimeout(tick, DRAFT_FIRST_MS);
  }

  function showDraft(state, text) {
    if (text === state.text) return;
    state.text = text;
    if (!text) {
      if (state.node) {
        state.node.remove();
        state.node = null;
        log.appendChild(state.typing);
        scroll();
      }
      return;
    }
    if (!state.node) {
      state.typing.remove();
      state.node = el('div', 'wau-chat__msg wau-chat__msg--bot wau-chat__msg--draft');
      state.node.appendChild(el('div', 'wau-chat__text'));
      log.appendChild(state.node);
    }
    state.node.firstChild.innerHTML = format(text);
    scroll();
  }

  function stopDraft() {
    if (!draft) return;
    clearTimeout(draft.timer);
    if (draft.node) draft.node.remove();
    draft = null;
  }

  // Ошибка прокси, а не сервера: у ответа wau.ru всегда есть поле enabled.
  // Эксперту реплика уходит быстро — там опрос ответа не нужен.
  function lost(data) {
    return data.status >= 500 && data.enabled === undefined && !withExpert();
  }

  function recover(typing, tries) {
    setTimeout(function () {
      call('poll', { after: lastId, replies: 1 }).then(function (data) {
        return data && !data.error && (data.messages || []).length ? data : null;
      }, function () {
        return null;
      }).then(function (data) {
        if (!data && tries > 1) {
          recover(typing, tries - 1);
          return;
        }
        stopDraft();
        typing.remove();
        busy = false;
        if (!data) {
          system(ui.error || 'Something went wrong. Please try again.');
          return;
        }
        data.messages.forEach(function (message) {
          render(message);
          noteExpert(message);
        });
        track('wau_chat_message');
        if (data.state === 'operator') {
          handedOver({ operatorMode: data.operatorMode });
        }
      });
    }, 3000);
  }

  function contact() {
    if (busy) return;
    busy = true;
    // waiting: окно покажет ответ помощницы, пока эксперт не подключился, —
    // без вопроса она попросит его задать.
    call('handover', { waiting: 1 }).then(function (data) {
      busy = false;
      if (!data.error) {
        render({ id: 0, role: 'assistant', blocks: data.blocks });
        renderChips(data.suggestions || []);
        track('wau_chat_contact');
        handedOver(data);
      }
    }, function () {
      busy = false;
    });
  }

  function render(message) {
    if (message.id > lastId) lastId = message.id;
    if (message.role === 'handover' || message.role === 'cart') return;
    var own = message.role === 'user';
    var expert = message.role === 'operator';
    var wrap = el('div', 'wau-chat__msg ' + (own ? 'wau-chat__msg--me' : 'wau-chat__msg--bot') + (expert ? ' wau-chat__msg--expert' : ''));
    if (expert) {
      var who = el('div', 'wau-chat__who');
      who.textContent = ui.expert || 'Expert';
      wrap.appendChild(who);
    }
    (message.blocks || []).forEach(function (block) {
      if (block.type === 'text' && block.text) {
        var p = el('div', 'wau-chat__text');
        own ? (p.textContent = block.text) : (p.innerHTML = format(block.text));
        wrap.appendChild(p);
        if (block.original) {
          // Эксперт писал по-русски: перевод на экране, оригинал — по нажатию.
          var mark = el('button', 'wau-chat__translated');
          mark.type = 'button';
          mark.textContent = ui.translated || 'translated';
          mark.addEventListener('click', function () {
            var shown = p.getAttribute('data-original') === '1';
            p.innerHTML = format(shown ? block.text : block.original);
            p.setAttribute('data-original', shown ? '0' : '1');
          });
          wrap.appendChild(mark);
        }
      } else if (block.type === 'order' && block.name) {
        wrap.appendChild(orderCard(block));
      } else if (block.type === 'products' && block.items && block.items.length) {
        wrap.appendChild(cards(block.items));
      } else if (block.type === 'link' && block.url) {
        var a = el('a', 'wau-chat__link');
        a.href = safeUrl(block.url);
        a.textContent = block.title || block.url;
        wrap.appendChild(a);
      }
    });
    // 👍/👎 — только под ответом модели: под «Эксперт завершил разговор»
    // оценивали эксперта, а минус доставался помощнику.
    if (!own && message.role === 'assistant' && message.id > 0 && message.rateable !== false) {
      wrap.appendChild(rating(message.id, message.rating));
    }
    log.appendChild(wrap);
    scroll();
  }

  function cards(items) {
    var list = el('div', 'wau-chat__cards');
    items.forEach(function (item) {
      var card = el('div', 'wau-chat__card');
      var link = el('a', 'wau-chat__card-link');
      link.href = safeUrl(item.url);
      link.addEventListener('click', function () {
        track('wau_chat_product_click');
      });
      if (item.image) {
        var img = el('img');
        img.src = item.image + (item.image.indexOf('?') < 0 ? '?' : '&') + 'width=240';
        img.alt = '';
        img.loading = 'lazy';
        link.appendChild(img);
      }
      var name = el('span', 'wau-chat__card-name');
      name.textContent = item.name;
      link.appendChild(name);
      var price = el('span', 'wau-chat__card-price');
      price.textContent = money(item.price, item.currency);
      if (item.oldPrice && item.oldPrice > item.price) {
        var old = el('s');
        old.textContent = money(item.oldPrice, item.currency);
        price.appendChild(document.createTextNode(' '));
        price.appendChild(old);
      }
      link.appendChild(price);
      card.appendChild(link);
      // Кнопка — только у товара с одним вариантом в наличии: вариант с
      // выбором (цвет, объём) покупатель выбирает на странице товара.
      if (item.available && item.variantId > 0 && ui.cart) {
        var add = el('button', 'wau-chat__cart');
        add.type = 'button';
        add.textContent = ui.cart;
        add.addEventListener('click', function () {
          addToCart(item, add);
        });
        card.appendChild(add);
      }
      list.appendChild(card);
    });
    return list;
  }

  // Карточка заказа из ответа: номер, дата, статус словами витрины, сумма,
  // ссылка на отслеживание. Трек ведёт на сайт перевозчика — единственная
  // ссылка окна за пределы магазина, только https и в новой вкладке.
  function orderCard(order) {
    var card = el('div', 'wau-chat__order');
    var head = el('div', 'wau-chat__order-head');
    head.textContent = (ui.order || 'Order') + ' ' + order.name;
    card.appendChild(head);
    var meta = el('div', 'wau-chat__order-meta');
    meta.textContent = [order.date ? new Date(order.date + 'T12:00:00').toLocaleDateString(cfg.locale || undefined) : '',
      ui['status_' + order.status] || '', order.total ? money(order.total, order.currency) : ''].filter(Boolean).join(' · ');
    card.appendChild(meta);
    var url = trackUrl(order.trackUrl);
    if (url) {
      var link = el('a', 'wau-chat__order-track');
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = (ui.track || 'Track parcel') + (order.trackCode ? ' ' + order.trackCode : '');
      card.appendChild(link);
    } else if (order.trackCode) {
      var code = el('div', 'wau-chat__order-meta');
      code.textContent = (order.carrier ? order.carrier + ' ' : '') + order.trackCode;
      card.appendChild(code);
    }
    return card;
  }

  function trackUrl(url) {
    try {
      var parsed = new URL(String(url || ''));
      return parsed.protocol === 'https:' ? parsed.href : '';
    } catch (e) {
      return '';
    }
  }

  // Корзина из чата — Ajax API корзины Shopify на адресе языка витрины.
  // Пометка wau_assistant в атрибутах корзины доходит до заказа: по ней
  // отчёт считает заказы, собранные в чате. Боковую корзину темы обновляет
  // и открывает её же событие cart:refresh; на телефоне окно чата — во весь
  // экран, поэтому перед этим закрывается.
  function addToCart(item, button) {
    var routes = (window.FoxTheme && window.FoxTheme.routes) || {};
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var cartUrl = routes.cart_url || root + 'cart';
    button.disabled = true;
    cartRequest((routes.cart_add_url || root + 'cart/add') + '.js', { items: [{ id: item.variantId, quantity: 1 }] })
      .then(function () {
        track('wau_chat_add_to_cart');
        // Отметка в разговоре — для доли разговоров с корзиной в отчёте.
        call('cart', { productId: item.id }).catch(function () {});
        button.textContent = ui.added || ui.cart;
        button.classList.add('wau-chat__cart--added');
        return cartRequest(root + 'cart/update.js', { attributes: { wau_assistant: 'chat' } }).catch(function () {});
      })
      .then(function () {
        var drawer = document.querySelector('cart-drawer');
        var pageCart = window.FoxTheme && window.FoxTheme.settings && window.FoxTheme.settings.cartType === 'page';
        if (!drawer || pageCart) {
          location.href = cartUrl;
          return;
        }
        if (window.matchMedia('(max-width: 639px)').matches) close();
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      }, function (error) {
        button.disabled = false;
        // Shopify сам пишет причину на языке витрины: «нет в наличии», «больше нет».
        system((error && error.description) || ui.error || 'Something went wrong. Please try again.');
      });
  }

  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (response) {
      return response.json().catch(function () {
        return {};
      }).then(function (json) {
        if (!response.ok) throw json;
        return json;
      });
    });
  }

  function rating(id, current) {
    var box = el('div', 'wau-chat__rate');
    [[1, '👍', ui.helpful || 'Helpful'], [-1, '👎', ui.unhelpful || 'Not helpful']].forEach(function (option) {
      var button = el('button', 'wau-chat__rate-btn');
      button.type = 'button';
      button.textContent = option[1];
      button.setAttribute('aria-label', option[2]);
      button.setAttribute('aria-pressed', current === option[0] ? 'true' : 'false');
      button.addEventListener('click', function () {
        box.querySelectorAll('button').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        button.setAttribute('aria-pressed', 'true');
        // Оценка — не важнее страницы: обрыв сети не должен сыпать ошибками.
        call('rate', { messageId: id, value: option[0] }).catch(function () {});
        if (option[0] === -1 && ui.contactChip) {
          renderChips([ui.contactChip]);
        }
      });
      box.appendChild(button);
    });
    return box;
  }

  // Пока на связи эксперт, звать его не нужно — как на wau.ru. Подписи нет
  // (старый сервер) — кнопки тоже нет.
  function expertButton() {
    callExpert.hidden = !ui.call_expert || withExpert();
  }

  function renderChips(list) {
    expertButton();
    chips.innerHTML = '';
    list.forEach(function (text) {
      var chip = el('button', 'wau-chat__chip');
      chip.type = 'button';
      chip.textContent = text;
      chip.addEventListener('click', function () {
        if (text === ui.resume) {
          resume();
        } else if (text === ui.contactChip) {
          contact();
        } else {
          ask(text);
        }
      });
      chips.appendChild(chip);
    });
    // Подсказки занимают место у ленты: без прокрутки низ ответа — кнопки
    // «в корзину» — оставался под ними.
    scroll();
  }

  function withExpert() {
    return state === 'operator' && mode === 'mg';
  }

  function handedOver(data) {
    var handover = data.handover || {};
    if ((data.operatorMode || handover.mode) !== 'mg') {
      return;
    }
    state = 'operator';
    mode = 'mg';
    expertNote(data);
  }

  function expertNote(data) {
    var note = ui.expertNote || '';
    if (data.offlineNote) note += ' ' + data.offlineNote;
    if (note) system(note);
    renderChips([ui.resume]);
    schedulePoll(0);
  }

  function noteExpert(message) {
    if (message.role === 'operator' && message.id > lastExpertId) {
      lastExpertId = message.id;
    }
  }

  function schedulePoll(delay) {
    clearTimeout(pollTimer);
    if (!withExpert() || !token) return;
    pollTimer = setTimeout(pollOnce, delay);
  }

  function pollOnce() {
    // waiting: эксперт долго молчит — сервер присылает сообщение помощника (один раз).
    call('poll', { after: lastExpertId, waiting: 1 }).then(function (data) {
      // Пока шёл опрос, покупатель нажал «Вопрос решён» — разговор уже у помощницы.
      if (!withExpert()) return;
      if (data.error) return schedulePoll(30000);
      var fresh = data.messages || [];
      fresh.forEach(function (message) {
        render(message);
        noteExpert(message);
      });
      var waiting = data.waiting && data.waiting.message;
      if (waiting) {
        render(waiting);
        var hints = data.waiting.suggestions || [];
        renderChips(hints.length ? hints.concat([ui.resume]) : [ui.resume]);
      }
      if ((fresh.length || waiting) && dialog.hidden) {
        unread(true);
      }
      if (data.state !== 'operator') {
        // Эксперт закрыл диалог в CRM — снова помощница.
        state = data.state || 'bot';
        mode = '';
        if (ui.closed) system(ui.closed);
        renderChips([]);
        return;
      }
      schedulePoll(!dialog.hidden && !document.hidden ? 3000 : 30000);
    }, function () {
      schedulePoll(30000);
    });
  }

  function resume() {
    clearTimeout(pollTimer);
    call('resume').then(function (data) {
      if (data.error) return;
      state = 'bot';
      mode = '';
      render({ id: data.messageId, role: 'assistant', blocks: data.blocks, rateable: data.rateable });
      renderChips(data.suggestions || []);
    });
  }

  function system(text) {
    var note = el('div', 'wau-chat__msg wau-chat__msg--system');
    note.textContent = text;
    log.appendChild(note);
    scroll();
  }

  // Текст ответа: экранирование, затем ссылки [текст](адрес), **жирный** и
  // пункты списка. Сервер уже убрал ссылки не на магазин; здесь — вторая проверка.
  function format(text) {
    var html = String(text || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    html = html.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (m, title, url) {
      return '<a href="' + safeUrl(url) + '">' + title + '</a>';
    });
    html = html.replace(/^[ \t]*[*-][ \t]+/gm, '• ');
    html = html.replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>');
    return html.replace(/\n/g, '<br>');
  }

  function safeUrl(url) {
    url = String(url || '');
    if (/^\/(?!\/)/.test(url)) return url;
    try {
      var parsed = new URL(url);
      if (parsed.protocol === 'https:' && (parsed.host === location.host || /(^|\.)wauglobal\.com$/.test(parsed.host) || /\.myshopify\.com$/.test(parsed.host))) {
        return parsed.href;
      }
    } catch (e) {}
    return '#';
  }

  function money(amount, currency) {
    try {
      return new Intl.NumberFormat(cfg.locale || undefined, { style: 'currency', currency: currency || 'USD' }).format(amount);
    } catch (e) {
      return amount + ' ' + (currency || '');
    }
  }

  function el(tag, className) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    return node;
  }

  function scroll() {
    log.scrollTop = log.scrollHeight;
  }

  function track(name) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name);
    } else if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: name });
    }
  }
})();
